import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import Footer from '../../components/Footer/footer';
import HeaderComponent from '../../components/Header';
import { PatientDetails } from './MyPatientHelpers';
import '../../static/css/styles.css';
import { appointmentActions } from '../../store/actions';
import { history } from '../../helpers/history';
import { constants } from '../../Constants';
import Loading from '../../components/Loading/Loading';
import {capitalizeFirstLetter} from '../../helpers/utils'

class MyPatients extends Component {
	constructor(props) {
		super(props);
	}

	componentWillMount() {
		this.props.getPatientsList();
		if (this.props.user !== undefined) {
			if (this.props.user.role === 1) {
				history.replace('/home');
			}
		}
	}

	patientDetailHandler(patientId){
		history.push({
			pathname: `/patient-details/${patientId}`,
			state: { isMyClientDetailView: true } 
		  });
	}



	render() {
		const { whitelabel } = this.props;
		if (this.props.patients !== undefined) {
			return (
				<div className="sh-layout">
					<HeaderComponent />
					<div className="sh-patient-dash-comp sh-gnrl-width sh-container-pd10">
						{/* Welcome Note */}
						<div className="sh-gnrl-welcome-note">
							<h2 className="sh-gnrl-welcome">
								MY {whitelabel && whitelabel[0] ? whitelabel[0].consumer_role.toUpperCase() : constants.PATIENT.toUpperCase()}S
							</h2>
						</div>

						{/* Session Div */}
						<div className="sh-gnrl-container">
							<div className="sh-gnrl-cont-content">
								{/* Header for counsellor */}
								{this.props.patients.length > 0 ? (
									<div className="sh-gnrl-cc-row">
										<div className="sh-gnrl-col-1">
											<span className="sh-gnrl-cchc-main-head">
												{`${whitelabel && whitelabel[0]
													? capitalizeFirstLetter(whitelabel[0].consumer_role)
													: capitalizeFirstLetter(constants.PATIENT)}
												 ${constants.NAME}`}
											</span>
										</div>
										<div className="sh-gnrl-col-2">
											<span className="sh-gnrl-cchc-main-head">{constants.SINCE_TXT}</span>
										</div>
										<div className="sh-gnrl-col-2">
											<span className="sh-gnrl-cchc-main-head">
												<i className="fa fa-bars"></i>
											</span>
										</div>
									</div>
								) : (
									<div className="sh-gnrl-cc-row">
										<div className="sh-gnrl-col-2">
											<span className="sh-gnrl-cchc-main-title">
												There are no{' '}
												{whitelabel && whitelabel[0]
													? whitelabel[0].consumer_role
													: constants.PATIENT}{' '}
												to show.
											</span>
										</div>
									</div>
								)}
								{this.props.patients.length > 0
									? this.props.patients.map((v, i) => {
										return (
											<div className="sh-gnrl-cc-row">
												<div className="sh-gnrl-col-1">
													<span className="sh-gnrl-cchc-main-title">
														{v.patient_name}
													</span>
												</div>
												<div className="sh-gnrl-col-2">
													<span className="sh-gnrl-cchc-main-title">
														{moment(v.date_created).format('YYYY-MM-DD')}
													</span>
												</div>
												<div onClick={() => this.patientDetailHandler(v.patient_id)} className="sh-gnrl-col-1 btn">
													<button
														className="sh-btn-detail sh-gnrl-btn-session "
														id={v.patient_id}
													>
														<span className="sh-text-icon">
															{constants.DETAILS_TXT}
														</span>
														<span className="icon"></span>
													</button>
												</div>
											</div>
										);
									})
									: null}
							</div>
						</div>
					</div>
					<Footer />
				</div>
			);
		} else {
			return <Loading />;
		}
	}
}

function mapStateToProps(state) {
	const { patients } = state.appointments;
	const { whitelabel } = state.whitelabel;
	return {
		patients,
		whitelabel,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		getPatientsList: () => {
			dispatch(appointmentActions.getPatientsList());
		},
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyPatients));



// WEBPACK FOOTER //
// ./src/screens/MyPatients/MyPatients.js